import { l } from '@manychat/manyui'

import { KnowledgeEntry, KnowledgeEntryType } from 'shared/api/requests/aiBusinessKnowledge/schemas'

export const getSidebarTitle = ({
  entry,
  newEntryType,
}: {
  entry: KnowledgeEntry | null
  newEntryType: string
}) => {
  if (!entry) {
    switch (newEntryType) {
      case KnowledgeEntryType.TEXT:
        return l.translate('New text')
      case KnowledgeEntryType.LINK:
        return l.translate('New link')
      case KnowledgeEntryType.FILE:
        return l.translate('New file')
      default:
        return ''
    }
  }

  if (entry.title) {
    return entry.title
  }

  return l.translate('Untitled')
}
